export const schemaToFields = (schema) => {
  if (!schema?.shape) return [];

  const fields = Object.keys(schema.shape).map((key) => {
    const zodField = schema.shape[key];
    const defaultValue = zodField.def?.defaultValue;
    const label = zodField.description;

    // Check if field is required by examining the Zod schema more thoroughly
    // A field is considered required if it's not explicitly optional AND has validation
    // A field is considered required if it's NOT optional/nullable
    let isRequired = true;
    let fieldType = zodField;

    // Unwrap Zod types
    while (fieldType._def) {
      const typeName = fieldType._def.typeName;
      if (typeName === 'ZodOptional' || typeName === 'ZodNullable') {
        isRequired = false;
        break;
      }
      if (fieldType._def.innerType) {
        fieldType = fieldType._def.innerType;
      } else if (fieldType._def.schema) {
        fieldType = fieldType._def.schema;
      } else {
        break;
      }
    }

    // For strings, also check if it has a min(1) constraint
    // If it's technically "not optional" but has no min(1), it can be "", which often means "not required" in UI terms
    if (isRequired && fieldType._def?.typeName === 'ZodString') {
      const hasMinConstraint = fieldType._def.checks?.some(
        (check) => check.type === 'min' && check.value >= 1
      );
      isRequired = hasMinConstraint;
    }

    return {
      name: key,
      label: label || key.charAt(0).toUpperCase() + key.slice(1),
      value: defaultValue,
      required: isRequired,
      isRequired: isRequired,
    };
  });

  return fields;
};

export const validateSchema = async (schema, values) => {
  const result = schema.safeParse(values);

  if (result.success) {
    return { success: true, errors: {} };
  }

  const errors = result.error.issues.reduce((acc, issue) => {
    const field = issue.path[0];
    if (!field) return acc;
    // Strip "Invalid input: " prefix if it exists
    let message = issue.message.replace(/^Invalid input: /, "");

    // Handle technical "expected string, received null" messages
    if (message.includes("expected string, received null") ||
      message.includes("Expected string, received null") ||
      issue.code === "invalid_type") {
      message = "This field is required";
    }

    acc[field] = { message };
    return acc;
  }, {});

  return { success: false, errors };
};
